import { render, staticRenderFns } from "./AchievementUnlockDialog.vue?vue&type=template&id=13c4331d&scoped=true"
import script from "./AchievementUnlockDialog.vue?vue&type=script&lang=js"
export * from "./AchievementUnlockDialog.vue?vue&type=script&lang=js"
import style0 from "./AchievementUnlockDialog.vue?vue&type=style&index=0&id=13c4331d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4331d",
  null
  
)

export default component.exports